import React from "react";

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 19 19"
      stroke="#333"
      stroke-width="2"
      className="react-time-picker__clear-button__icon react-time-picker__button__icon"
    >
      <line x1="4" x2="15" y1="4" y2="15"></line>
      <line x1="15" x2="4" y1="4" y2="15"></line>
    </svg>
  );
};

export default CloseIcon;
